import { Col, Row } from "antd";
import { GradientButton } from "components/GradientButton";
import React, { FC } from "react";
import CardBuild from "./components/CardBuild";
import CardExplore from "./components/CardExplore";
import styles from "./styles.module.css";

const ExploreAndBuild: FC = () => {
  return (
    <section className={styles.root}>
      <img className={styles.image} src="/images/landing/rectangle.svg" />
      <div className="container-lg">
        <h1>Explore and BUILD - It’s that Simple!</h1>
        <Row gutter={[22, 52]}>
          <Col xs={24} md={10}>
            <CardExplore />
          </Col>

          <Col className="f-center" xs={24} md={4}>
            <img
              className={styles.arrowImage}
              src="/images/landing/arrow.svg"
              alt="arrow"
            />
          </Col>

          <Col xs={24} md={10}>
            <CardBuild />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ExploreAndBuild;
